class WoodLasProductCraft extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.video = this.querySelector('video');
    if (!this.video) return;
    document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, options);
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && !this.video.paused) this.video.pause();
    }, { threshold: 0.1 });
    this.observer.observe(this.video);
  }
  disconnectedCallback() {
    this.video?.pause();
    this.observer?.disconnect();
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('woodlas-product-craft')) customElements.define('woodlas-product-craft', WoodLasProductCraft);
